import { render } from "./ForgotPasswordUpdateView.vue?vue&type=template&id=675d9966"
import script from "./ForgotPasswordUpdateView.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordUpdateView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__